angular.module('core')
  .service('schoolApi', ['$filter', 'cancelableResourceFactory', 'cancelableResourceManager', '$state', 'highlightsApi', 'transformResponse', 'timeframe', 'exportService', function ($filter, $cancelableResourceFactory, $cancelableResourceManager, $state, $highlightsApi, $transformResponse, $timeframe, $exportService) {
    var self = this;

    var schoolSettingsMapping = function(body) {
      try {
        var school = JSON.parse(body);
        school.admins = school.admins || [];
        school.start_time = school.start_time || '';
        school.end_time = school.end_time || '';
        school.type = 'school';
        return school;
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var schoolNavigationMapping = function(school) { };

    var schoolReportingMapping = function(school) {
      school.activeStudents = school.count_active_students;
      school.averageMonthlySessionTime = school.average_monthly_session_time;
      school.extendedUsage = school.percent_usage_extended_hours;
      school.lessonsCompletedThisYear = school.count_lessons_completed;
      school.averageGrowth = school.percent_growth;
    };

    var SchoolSettings = $cancelableResourceFactory.createCacheableResource(null, '/m/school/:id/settings', {id: '@id'}, {
      get: {
        transformResponse: schoolSettingsMapping,
        url: '/m/school/:id/settings',
        method: 'GET'
      }
    });

    var SchoolRoster = $cancelableResourceFactory.createCacheableResource(null, '/m/mschools/:id/students', {
      id: '@id'
    }, {
      school: {
        url: '/m/mschool/:id/students',
        method: 'GET',
        transformResponse: function(body) {
          var roster = JSON.parse(body);
          return roster;
        }
      }
    });

    var SchoolNavigation = $cancelableResourceFactory.createCacheableResource('SchoolNavigation', '/n/districts/:districtId/schools', {id: '@id'},
    {
      query: {
        cache: true,
        url: '/n/districts/:districtId/schools',
        method: 'GET',
        isArray: true,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationQuery('school', body, schoolNavigationMapping);
        }
      },
      customer: {
        cache: true,
        url: '/m/customer/schools',
        method: 'GET',
        isArray: true,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationQuery('school', body, schoolNavigationMapping);
        }
      },
      get: {
        cache: true,
        url: '/n/districts/:districtId/schools?school_id=:school_id',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationGet('school', body, schoolNavigationMapping);
        }
      }
    });

    var ClassroomTeachers = $cancelableResourceFactory.createCacheableResource(
      'ClassroomTeachers',
      '/r/districts/:districtId/schools/:schoolId/classroom-teachers',
      {});

    var schoolReportingUrl = '/r/districts/:districtId/schools';

    var SchoolReporting = $cancelableResourceFactory.createCacheableResource(null, schoolReportingUrl, {id: '@id'}, {
      query: {
        url: schoolReportingUrl,
        method: 'GET',
        isArray: true,
        transformResponse: function(body, headersGetter, status) {
            return $transformResponse.transformReportingQuery('school', body, schoolReportingMapping, status);
        }
      },
      getFrequency: {
        url: '/r/districts/:districtId/schools/frequency',
        method: 'GET',
        cache: false,
        isArray: false,
        transformResponse: $transformResponse.transformResponseToJson
      },
      getBubbleGraph: {
        url: '/r/districts/:districtId/schools/bubblegraph',
        method: 'GET',
        isArray: false,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformBubbleGraph('school', body, schoolReportingMapping);
        }
      }
    });

    /**************************************************************/
    /*                        Navigation Api                      */
    /**************************************************************/

    var getSchoolsReportingParams = function() {
      var params = _.pick($state.params, ['districtId', 'sort', 'order']);
      params.grade_id = $state.params.gradeId || undefined;
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      params.start = $state.current.data.page || undefined;
      params.seed = $state.params.seed;
      return params;
    };

    self.getSchoolsReportingExportUrl = function() {
      var params = getSchoolsReportingParams();
      return $exportService.buildExportUrl(schoolReportingUrl, params);
    };

    self.getSchoolsReporting = function() {
      var params = getSchoolsReportingParams();
      var promises = SchoolReporting.query(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getSchoolsFrequency = function() {
      var params = _.pick($state.params, ['districtId']);
      params.grade_id = $state.params.gradeId || undefined;
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      var promises = SchoolReporting.getFrequency(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getSchoolsClusterData = function(callback) {
      var params = _.pick($state.params, ['districtId']);
      params.grade_id = $state.params.gradeId || undefined;
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      var promises = SchoolReporting.getBubbleGraph(params);
      promises.$promise.then(callback);
      return promises;
    };

    self.getSchools = function(callback) {
      var params = _.pick($state.params, ['districtId']);
      params.grade_id = $state.params.gradeId || undefined;
      // TODO: looks like we're calling callback twice?
      var promises = SchoolNavigation.query(params, callback);
      promises.$promise.then(callback);
      return promises;
    };

    self.getCustomerSchools = function(callback) {
      var promises = SchoolNavigation.customer({});
      promises.$promise.then(callback);
      return promises;
    };

    self.getSchoolsForGrade = function(grade_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.grade_id = grade_id;
      var promises = SchoolNavigation.query(params, callback);
      return promises;
    };

    self.getSchool = function(school_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = school_id;
      params.grade_id = $state.params.gradeId || undefined;
      var promises = SchoolNavigation.get(params);
      promises.$promise.then(callback);
      return promises;
    };

    // deprecated: use getSchoolHighlights
    self.getSchoolData = function(school_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = school_id;
      params.grade_id = $state.params.gradeId || undefined;
      params.sy = $timeframe.calculateCurrentReportingYear();

      var promises = $highlightsApi.SchoolHighlights.get(params);
      promises.$promise.then(callback);
      return promises;
    };

    self.getSchoolHighlights = function(params) {
      return $highlightsApi.SchoolHighlights.get(params).$promise;
    };

    /**************************************************************/
    /*                         Settings Api                       */
    /**************************************************************/

    self.getStudentsForSchoolFromMagneto = function(school_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = school_id;
      //params.grade_id = $state.params.gradeId;
      var promises = SchoolRoster.query(params);
      promises.$promise.then(callback);
      return promises;
    };

    self.getSchoolSettings = function(scid, success, error) {
      var promises = SchoolSettings.get({id: scid});

      promises.$promise.then(function(school) {
        school.type = 'school';
        success(school);
      });
      return promises;
    };

    self.saveSchoolSettings = function(item, success, error) {
      console.log(item);
      var school = new SchoolSettings(item);
      school.$save([], success, error);
    };

    /**************************************************************/
    /*                         Customer Usage Api                 */
    /**************************************************************/
    var getDistrictCustomersUsageParams = function () {
      var params = _.pick($state.params, ['districtId']);
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      params.untilNow = true;
      return params;
    };

    var customersUsageReportingMapping = function(usageItem) {
        usageItem.status = null;
        usageItem.id = usageItem.school.id;
        usageItem.schoolId = usageItem.school.id;
        usageItem.schoolName = usageItem.school.name;
    };
    var customerUsageReportingUrl = '/r/districts/:districtId/customers/usage';
    var CustomerUsageReporting = $cancelableResourceFactory.createCacheableResource(null, customerUsageReportingUrl, { }, {
      query: {
        url: customerUsageReportingUrl,
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
            return $transformResponse.transformAggregationQuery('usage', body, customersUsageReportingMapping, 'school');
        }
      }
    });

    self.getDistrictCustomersUsage = function() {
        var params = getDistrictCustomersUsageParams();
        var promises = CustomerUsageReporting.query(params);
        $cancelableResourceManager.addAndRemoveOnFinish(promises);
        return promises.$promise;
    };

    self.getDistrictCustomersUsageExportUrl = function() {
      var params = getDistrictCustomersUsageParams();
      return $exportService.buildExportUrl(customerUsageReportingUrl, params);
    };

    /**************************************************************/
    /*                         Other                              */
    /**************************************************************/

    /**
     * Get all of the classrooms for a school along with the teachers for the classrooms.
     *
     * Return value is
     * {
     *   "data": {
     *     "classrooms": [
     *       {
     *         "classroom": {<classroom attributes>},
     *         "teachers": [{<teacher attributes>}, ...]
     *       },
     *       ...
     *     ]
     *   }
     * }
     *
     * @param districtId
     * @param schoolId
     * @return {*}
     */
    self.getClassroomTeachers = function(districtId, schoolId) {
      var promises = ClassroomTeachers.get({
        districtId: districtId,
        schoolId: schoolId
      });
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

  }]);
